/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Indica = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Indica"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M18 20v2H6v-2zm2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2v2l-.206-.005a4 4 0 0 1-3.79-3.789L2 18V6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-3.794 3.995L18 22v-2a2 2 0 0 0 2-2"
      />
      <path fill="#0E0E0E" d="M11.128 17V7.19h1.74V17z" />
    </g>
  </svg>
);

export const IndicaIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'indica-icon'}
      icon={Indica}
      {...props}
      size={size}
    />
  );
};
